export default __webpack_public_path__ + "static/media/lab_background2.192de5b8.png";